import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {AgendaEventModel} from '../../../api/entity/agendaEvent.model';
import {AgendaEventConverter} from '../../../api/entity/converter/agendaEventConverter';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable({
    providedIn: 'root',
})
export class AgendaEventDataService extends AbstractDataServiceV2<AgendaEventModel, AgendaEventConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: AgendaEventConverter) {
        super('AgendaEvent', http, httpUrlGenerator, logger, config, converter);
    }
}
